module.exports = __webpack_public_path__ + "static/heavy_yuleba3-d058084a0ec50e16db456da6971bdcbd.jpg";